import React, { useEffect, useState } from "react";
import ModalComponent from "../../../components/modals";
import LaddaButton from "../../../components/buttons/laddaButton";
import SimpleSelect from "../../../components/selects/simpleSelect";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Grid } from "@mui/material";
import {
  callActionApiAsync,
  postSaveBiomedicalEquipmentModelAdverseEvent
} from "../../../services/apiService";
import ToastNotification from "../../../components/toastNotification";

const validationSchema = yup.object({
  typeEventId: yup
    .number()
    .typeError("El tipo de suceso es obligatorio")
    .required("El tipo de suceso es obligatorio"),
  gravityLevelId: yup
    .number()
    .typeError("La gravedad es obligatoria")
    .required("La gravedad es obligatoria")
});

const ModelAdverseEventsModal = ({
  open,
  close,
  modelId,
  userId,
  typeEventOptions,
  gravityOptions,
  onSaved,
  isViewer
}) => {
  const [showToast, setShowToast] = useState(false);
  const [toastConfig, setToastConfig] = useState({
    severity: "warn",
    summary: "",
    detail: ""
  });

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      typeEventId: "",
      gravityLevelId: ""
    }
  });

  useEffect(() => {
    if (!open) return;
    reset({ typeEventId: "", gravityLevelId: "" });
  }, [open, reset]);

  const handleClose = () => {
    reset({ typeEventId: "", gravityLevelId: "" });
    close();
  };

  const onSubmit = async (formData) => {
    await callActionApiAsync(
      () =>
        postSaveBiomedicalEquipmentModelAdverseEvent({
          userId,
          modelId,
          typeEventId: formData.typeEventId,
          gravityLevelId: formData.gravityLevelId
        }),
      () => {
        onSaved?.();
        handleClose();
      },
      (error) => {
        setToastConfig({
          severity: "error",
          summary: "Eventos adversos por modelo",
          detail:
            typeof error === "string" && error
              ? error
              : "No se pudo agregar la combinación al modelo."
        });
        setShowToast(true);
      }
    );
  };

  return (
    <>
      <ModalComponent
        open={open}
        handleClose={handleClose}
        title="Agregar evento adverso al modelo"
        actions={<div className="HContainer j-center w-complete mt-10"></div>}
        maxWidth="780px"
      >
        <ToastNotification
          showToast={showToast}
          setShowToast={setShowToast}
          severity={toastConfig.severity}
          summary={toastConfig.summary}
          detail={toastConfig.detail}
        />

        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <p className="create-label">Tipo de Suceso:</p>
              <SimpleSelect
                name="typeEventId"
                control={control}
                options={typeEventOptions}
                hideLabel
                error={errors.typeEventId}
                margin={"0"}
                disabled={isViewer}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <p className="create-label">Gravedad:</p>
              <SimpleSelect
                name="gravityLevelId"
                control={control}
                options={gravityOptions}
                hideLabel
                error={errors.gravityLevelId}
                margin={"0"}
                disabled={isViewer}
              />
            </Grid>
            <Grid item xs={12} className="HContainer j-center mt-15">
              <LaddaButton type="submit" variant="contained" disabled={isViewer}>
                Agregar
              </LaddaButton>
            </Grid>
          </Grid>
        </form>
      </ModalComponent>
    </>
  );
};

export default ModelAdverseEventsModal;
